// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6jkd5","col":"styles_col__1YL1n"};